import { render, staticRenderFns } from "./roleTableU.vue?vue&type=template&id=4c1e9a60"
import script from "./roleTableU.vue?vue&type=script&lang=js"
export * from "./roleTableU.vue?vue&type=script&lang=js"
import style0 from "./roleTableU.vue?vue&type=style&index=0&id=4c1e9a60&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports